export default __webpack_public_path__ + "static/media/license_number.c9c1f4a0.webp";